module.exports = __webpack_public_path__ + "img/funds-fill.5d374cd1.svg";